import React from 'react';
import { render } from '@testing-library/react';
import { MoreDetails } from './MoreDetails';

describe('MoreDetails', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<MoreDetails
				full="10.201351313215125133513531"
				short="10.20"
				direction="r"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
